'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}

const _=require('pulsar-utils/dist-es6/_');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

ItemPickerController=function(){_createClass(ItemPickerController,null,[{key:'$inject',get:function()
{
return['$scope'];
}}]);

function ItemPickerController($scope){var _this=this;_classCallCheck(this,ItemPickerController);
this.items=this.items||[];
this._selectedItem=this.selectedItem||void 0;
this.selectedIndex=this.selectedIndex||-1;

$scope.$watchGroup([
'controller.items',
'controller.selectedItem',
'controller.selectedIndex'],
function(){return _this._reevaluateSelection()});

this._reevaluateSelection();
}ItemPickerController.prototype.

_reevaluateSelection=function _reevaluateSelection(){
if(_.exists(this.items)&&this.items.length>0&&!_.exists(this.selectedItem)){
this.selectedItem=this.items[0];
}

const newIndex=this.items.indexOf(this.selectedItem);
if(this.selectedIndex!==newIndex){
this.selectedIndex=newIndex;
}

if(this.selectedIndex===-1){
this.selectedItem=void 0;
}
};ItemPickerController.prototype.

goToNextItem=function goToNextItem(){
if(this.selectedIndex<this.items.length-1){
this.selectedIndex+=1;
this.selectedItem=this.items[this.selectedIndex];
}
};ItemPickerController.prototype.

goToPreviousItem=function goToPreviousItem(){
if(this.selectedIndex>0){
this.selectedIndex-=1;
this.selectedItem=this.items[this.selectedIndex];
}
};_createClass(ItemPickerController,[{key:'selectedItem',get:function()

{
return this._selectedItem;
},set:function(

selectedItem){
if(this._selectedItem===selectedItem)
return;

this._selectedItem=selectedItem;
}}]);return ItemPickerController}();let


ItemPickerDirective=function(_BaseControllerBacked){_inherits(ItemPickerDirective,_BaseControllerBacked);function ItemPickerDirective(){_classCallCheck(this,ItemPickerDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}_createClass(ItemPickerDirective,[{key:'templateUrl',get:function()
{throw new Error('Please supply a template url.')}},{key:'objectBindings',get:function()
{return['items','selectedIndex','selectedItem','itemFormatter']}},{key:'controller',get:function()
{
return ItemPickerController;
}}]);return ItemPickerDirective}(BaseControllerBackedDirective);


module.exports=ItemPickerDirective;
module.exports.DirectiveController=ItemPickerController;
//# sourceMappingURL=itemPickerDirective.js.map
